// Changes button text from div to span

customElements.whenDefined('custom-button').then(() => {
  const OriginalButton = customElements.get('custom-button');

  Object.defineProperty(OriginalButton.prototype, 'contentElement', {
    get() {
      if (this._contentElement) return this._contentElement;
      this._contentElement = document.createElement('span');
      this._contentElement.append(...this.childNodes);
      return this._contentElement;
    }
  });

  document.querySelectorAll('[is="custom-button"]').forEach(btn => {
    const div = btn.querySelector(':scope > div');
    if (div) {
      const span = document.createElement('span');
      span.append(...div.childNodes);
      div.replaceWith(span);
      btn._contentElement = span;
    }
  });
});